/*
 * nav/sagas
 *
 * Actions may be watched, but sagas should only ever call actionCreators,
 * and should not dispatch actions directly.
 */

import { call, put, takeLatest } from "redux-saga/effects";

import api from "../../api";
import modal from "../shared/actions";
import fetchInitialData from "../shared/sagas";
import { nav } from "./actions";
import { LOGIN_START, LOGOUT_START } from "./constants";

export function* loginSaga() {
  try {
    const { response } = yield call(api.User.get);
    localStorage.setItem("user", JSON.stringify(response));
    yield put(nav.loginSuccess(response));
    yield call(fetchInitialData);
  } catch (error) {
    localStorage.clear();
    yield put(nav.loginFailed(error));
    if (JSON.stringify(error).includes('"status":403')) {
      yield put(modal.open("ACCESS_DENIED"));
    }
  }
}

function* logoutSaga() {
  localStorage.clear();
  yield put(nav.logoutSuccess());
}

export function* watchLogin() {
  yield takeLatest(LOGIN_START, loginSaga);
}

export function* watchLogout() {
  yield takeLatest(LOGOUT_START, logoutSaga);
}
